import { render, staticRenderFns } from "./InformacoesDistrito.vue?vue&type=template&id=72537e91"
import script from "./InformacoesDistrito.vue?vue&type=script&lang=ts"
export * from "./InformacoesDistrito.vue?vue&type=script&lang=ts"
import style0 from "./InformacoesDistrito.vue?vue&type=style&index=0&id=72537e91&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports